import React, { useState, useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import ActivityDataPieChart from '../ActivityData/ActivityDataPieChart';
import { Loader } from '@/components/custom/loader';
import { ComplementaryActivityEvaluationCardHeader } from '@/pages/complementary-activity/complementary-activity-evaluation/complementary-activity-evaluation-card-header';
import ActivityStudentCard from '@/components/custom/complementary-activity-legacy/activityStudentCard';
import { useTranslation } from 'react-i18next';
import { DashboardContent } from '@/layouts/dashboard';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import ActivityEvaluationListTeacher from '@/pages/complementary-activity/PlayfulTeacher/ActivityEvaluationListTeacher';

// Rota compartilhada entre os temas — o professor playful ganha uma tela
// mocada própria (ver PlayfulTeacher/ActivityEvaluationListTeacher.jsx);
// o admin/Default abaixo continua intocado, com dados reais via API.
export function ActivityEvaluationArchive(props) {
  const isPlayfulTeacherTheme = usePlayfulTeacher();
  if (isPlayfulTeacherTheme) return <ActivityEvaluationListTeacher {...props} />;
  return <ActivityEvaluationArchiveDefault {...props} />;
}

function ActivityEvaluationArchiveDefault(props) {
  const { uri } = props;

  const { t } = useTranslation();
  const client = useClient();
  const [isLoading, setIsLoading] = useState(true);
  const [activity, setActivity] = useState();
  const [activityStudents, setActivityStudents] = useState();
  const [activityReport, setActivityReport] = useState();

  useEffect(() => {
    getActivity();
    getActivityStudents();
  }, []);

  useEffect(() => {
    if (activity?.id) {
      getActivityReport();
    }
  }, [activity]);

  const getActivity = async () => {
    try {
      setIsLoading(true);
      const { data } = await client.fetch(['activities', props.id]);
      setActivity(data);
    } catch (e) {
      console.error(e);
      toast.error(t('toast.errorGetActivity'));
    }
  };

  const getActivityReport = async () => {
    setIsLoading(true);
    const { data } = await client.fetch(['activities', activity.id, 'activities_report?general=true']);
    setActivityReport(data);
    setIsLoading(false);
  };

  const getActivityStudents = async () => {
    try {
      const { data } = await client.fetch(['activities', props.id, 'activity_students']);
      setActivityStudents(data);
    } catch (e) {
      console.error(e);
      toast.error('Erro ao buscar atividades dos estudantes.');
    }
  };

  const breadcrumbs = {
    title: 'Atividades',
    nav: [
      {
        route: '/atividade-complementar',
        name: 'Atividade Complementar',
        isActive: false
      },
      {
        route: uri,
        name: activity?.title,
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      className="animate-fade-in"
      breadcrumbs={breadcrumbs}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <ComplementaryActivityEvaluationCardHeader activity={activity} />

          <div className="page">
            <div className="page__col">
              {activityStudents && activityStudents.length > 0 ? (
                <div className="round-dg-wrapper">
                  <table className="round-dg round-dg--light">
                    <tbody className="round-dg__body">
                      {activityStudents.map(activityStudent => (
                        <ActivityStudentCard
                          activity={activity}
                          activityStudent={activityStudent}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="new-questions__empty-state-text">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  {t('activity.emptyInfo')}
                </p>
              )}
            </div>

            <div className="page__aside">
              <div className="chart-widget">
                <div className="chart-widget__header">
                  <h3 className="chart-widget__title">{t('activity.totalSubmissions')}</h3>
                </div>
                <div className="chart-widget__body">{isLoading ? <Loader /> : <ActivityDataPieChart activityReport={activityReport} />}</div>
              </div>
            </div>
          </div>
        </>
      )}
    </DashboardContent>
  );
}
